import { Box, Grid } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import DoctorScheduleApi from 'api/counter/doctor-schedule.api'
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import { getBranch } from 'utils/app.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import RemunerationList from './RemunerationList'

/** STYLE */
import { KEY_STORAGE } from 'constants/common'
import useStyles from 'features/counter/doctor-schedule/style'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import RadioButton from 'new-components/buttons/radio-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import { UseSnCode } from 'utils/useSnCode'
import ExportToExcel from './ExportToExcel'

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

interface DentistInterface {
  dentistId: number
  dentistFullname: string
}

export default function Remuneration() {
  const { t } = useTranslation()
  const history = useHistory()
  const classes = useStyles()
  const componentRef = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange

  const [selectedOptionPrice, setSelectedOptionPrice] = useState<any>(localStorage.getItem(KEY_STORAGE.REPORT_CONDITION) || 'TREATMENT')
  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)

  const [prefix, setPrefix] = useState<string>('ALL')
  const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])

  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [selectDoctors, setSelectDoctors] = useState<any[]>(['ALL'])
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const [remunerationData, getRemunerationData] = useState<any[]>([])
  const [remunerationPage, setRemunerationPage] = useState<number>(1)
  const [remunerationLimitPage, setRemunerationLimitPage] = useState<number>(10)
  const [remuretionTypePage, setRemurationTypePage] = useState<number>(1)
  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])

  const setDoc = (data: any) => {
    const sortedSelectData = data.sort((a: any, b: any) => {
      const idA = a.dentistId
      const idB = b.dentistId
      return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
    })
    return sortedSelectData
  }
  const filter = [
    branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn')}`,
    rangeDate[0],
    rangeDate[1],
    prefix === 'ALL' ? `${t(`REPORT.FILTER.ALL`)}` : prefix,
    _.isEmpty(selectDoctors)
      ? ` ${t('REPORT.FILTER.NO_SELECT')}`
      : selectDoctors.filter((i) => typeof i === 'number').length === doctors.length
        ? `${t('REPORT.FILTER.ALL')}`
        : `${setDoc(doctors.filter((d: any) => selectDoctors.includes(d.userId)))
          ?.map((d: any) => d.fullname)
          .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
          .join(', ')}`
  ]

  const [loading, setLoading] = useState<boolean>(true)
  const [checked, setChecked] = useState<boolean>(false)
  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'REMUNERATION') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    // ClinicApi.allBillPrefix()
    //   .then(({ data }) => setReceiptPrefix(data))
    //   .catch((e) => {
    //     return
    //   })

    ClinicApi.allBillPrefix()
      .then(({ data }) => {
        const filteredData = data.map((item: any) => ({ value: item.prefix, name: item.prefix }))
        setReceiptPrefix([...filteredData])
      })
      .catch((e) => {
        return
      })

    ClinicApi.findAllDoctors()
      .then((resp) => {
        setDoctors(resp.data)
      })
      .catch((e) => {
        return
      })

    DoctorScheduleApi.findAllDoctor({ branchId: branchId }).then(({ data: dataAllDoctor }) => {
      const dentists: DentistInterface[] = dataAllDoctor.map((d: any) => {
        return {
          dentistId: d.userId,
          dentistFullname: d.fullname
        }
      })
      setDoctorsMultiple(dentists)
      setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
    })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])

  const fetchRemuneration = useCallback(() => {
    let condition: FindAllReportInterface = {
      page: remunerationPage,
      pageLimit: remunerationLimitPage,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      optionPrice: selectedOptionPrice
    }

    if (doctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (rangeDate) {
      if (rangeDate[0] !== null && rangeDate[1] !== null) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }

    ReportApi.reportRemuneration(condition)
      .then(({ headers, data }) => {
        getRemunerationData(data)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [remunerationLimitPage, remunerationPage, remuretionTypePage, sortBy, sortType, branchId, prefix, selectDoctors, doctors, rangeDate, selectedOptionPrice])

  const exportExcel = async () => {
    setLoading(true);
    try {
      await ExportToExcel({
        data: remunerationData,
        doctors: doctorsMultiple,
        branches,
        branchId,
        filter,
        filterDateStart: rangeDate[0],
        filterDateEnd: rangeDate[1],
        snType: snType,
        t,
      })
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    } finally {
      setLoading(false);
    }
  }


  const handleFilterDoctors = (value: any) => {
    if ((value === 'ALL' && _.size(selectDoctors.filter((item) => typeof item === 'number')) === _.size(doctors)) || value === 'CLEAR') setSelectDoctors([''])
    else if (value === 'ALL') setSelectDoctors([..._.map(doctors, (d: any) => d.userId)])
    else if (_.includes(selectDoctors, value)) setSelectDoctors(_.filter(selectDoctors, (d) => d !== value))
    else setSelectDoctors([...selectDoctors, value])
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setRemunerationLimitPage(limit)
  const handleChangePage = (val: number) => setRemunerationPage(val)

  /** UseEfect */
  useEffect(() => {
    fetchRemuneration()
  }, [])

  const onLoadData = () => {
    fetchRemuneration()
  }

  const doctorOptions = doctors.map(d => ({
    id: d.userId,
    name: d.fullname
  }))

  const handleDoctorChange = (selected: any[]) => {
    const selectableIds = doctors.map((o: any) => o.id)
    const allSelected = selectableIds.every((id: any) => selectDoctors.includes(id))
    if (selected.includes(null)) {
      if (allSelected) {
        setSelectDoctors([])
      } else {
        setSelectDoctors(selectableIds)
      }
    } else {
      setSelectDoctors(selected as number[])
    }
  }

  return (
    <Box sx={{ overflowX: 'unset' }}>
      <HeaderCard text={t(`REPORT.REPORT_NAME.REMUNERATION`)} />
      <Box padding="16px">
        <Box>
          <RadioButton
            name="radio-buttons-group"
            onChange={(e) => {
              localStorage.setItem(KEY_STORAGE.REPORT_CONDITION, e.target.value.toString())
              setSelectedOptionPrice(e.target.value)
            }}
            row={true}
            sx={{ gap: '8px' }}
            value={selectedOptionPrice}
            options={[
              { label: t('REPORT.FILTER.PRICE_OF_TREATMENT'), value: 'TREATMENT', },
              { label: t('REPORT.FILTER.ACTUAL_PRICE_PAID'), value: 'PAID', }]}
          />
        </Box>
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={4} xl={2}>
            <SelectInput
              onChange={(e) => {
                setBranchId(e.target.value)
                setRemunerationPage(1)
              }}
              options={_.map(branches, (item) => ({ value: item.branchId, name: item.branchName || item.branchNameEn }))}
              value={branchId}
              defaultValue={`${_.get(_.find(branches, { branchId: branchId }), 'branchName' || 'branchNameEn')} `}
              label={t('REPORT.FILTER.BRANCH')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={2}>
            <InputSecondNewRangePicker
              inputHeight={40}
              value={rangeDate || emptyRangePicker}
              onchange={(val: any) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                setRemunerationPage(1)
                setRemunerationLimitPage(1)
              }}
              label={`${t('REPORT.TABLE.DECREASE.DATE_START')} » ${t('REPORT.TABLE.DECREASE.DATE_END')}`}
              allowClear
              onClear={() => setRangeDate(emptyRangePicker)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={2}>
            <SelectInput
              onChange={(e) => {
                setPrefix(e.target.value)
                setRemunerationPage(1)
                setRemurationTypePage(1)
              }}
              options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') }, ...receiptPrefix]}
              value={prefix}
              label={t('REPORT.FILTER.RECEIPT_TYPE')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={2} onClick={() => {
            setChecked(!checked)
            setRemunerationPage(1)
          }}>
            <SelectCheckBoxInput
              label={t('REPORT.FILTER.DOCTOR')}
              options={doctorOptions}
              selected={selectDoctors}
              onChange={handleDoctorChange}
              fullWidth
              helperText={''}
              loading={false}
              disabled={false}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={8} xl={4}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <MainButton
                title={t('INPUT.SEARCH')}
                onClick={() => {
                  setRemunerationPage(1)
                  onLoadData()
                }}
                type={'primary'}
                variant={'contained'}
              />
              <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                if (e === 'Excel') exportExcel()
                if (e === 'PDF') {
                  const style = document.createElement("style");
                  style.innerHTML = `
                      @media print {
                        @page { size: landscape }
                        }
                    `;
                  document.head.appendChild(style);
                  window.print();
                  document.head.removeChild(style);
                }
              }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box padding={'16px'}>
        <RemunerationList
          filter={filter}
          page={remunerationPage}
          pageLimit={remunerationLimitPage}
          rowCount={rowCount}
          sortBy={sortBy}
          sortType={sortType}
          data={remunerationData}
          doctors={doctorsMultiple}
          onRequestSort={onRequestSort}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleChangePage={handleChangePage}
          filterDateStart={rangeDate[0]}
          filterDateEnd={rangeDate[1]}
          componentRef={componentRef}
        />
      </Box>
    </Box >
  )
}



